<template>
    <b-container fluid class="px-0 d-flex flex-column animate__animated animate__fadeIn animate__duration-0.3s">
        <div class="main">
            <b-row no-gutters class="h-100">
                <b-col cols="3" class="h-100">
                    <div class="main-col border-right p-4">
                        <div class="logo-wrap text-center mb-3">
                            <img class="logo-wrap-img" src="@/assets/imgs/logo/logo.png" alt="PROOFY">
                        </div>
                        <div class="predicted-score-wrap border rounded-lg d-flex align-items-center p-3">
                            <div
                                class="predicted-score-wrap-text rounded-circle text-center text-primary font-weight-bolder h3 mr-3 my-0">
                                <countTo :startVal="0" :endVal="totalScore" :duration="1000"></countTo>
                            </div>
                            <div class="predicted-score-wrap-title d-flex flex-column justify-content-center flex-1">
                                <div class="predicted-score-wrap-title-text text-dark font-weight-bolder h5">Predicted Score
                                </div>
                                <div class="predicted-score-wrap-title-tip">
                                    <b-link
                                        class="p-0 text-secondary h6 m-0 text-underline text-truncate d-inline-block w-100"
                                        @click="handleModalShow('works')">
                                        See how predictive score works
                                    </b-link>
                                    <Modal :show="show.works" title="See how predictive score works"
                                        @onClose="handleModalClose('works')">
                                        <template v-slot:content>
                                            <p>Discover our AI-powered TOEFL Essay Scoring System!</p>
                                            <p class="my-4">Our innovative technology analyzes your essays on four crucial
                                                axes,
                                                each scored from 0 to 5: Addressing the Topic and Task, Organization and
                                                Development, Unity, Progression, and Coherence, and Language Use. Embrace
                                                accurate feedback with our system's ability to recognize subtle
                                                improvements,
                                                allowing for fractional scores like 4.5 or 5.</p>
                                            <p class="my-4">Enhance your TOEFL essay writing skills with our advanced
                                                scoring
                                                system and gain the competitive edge you need for exam success!</p>
                                        </template>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                        <div class="border-top my-3"></div>
                        <div class="h6 text-dark mb-3">Organization Feedback</div>
                        <div class="score-wrap border rounded-lg p-3">
                            <div v-for="(item, index) in scoreResults " :key="index"
                                class="score-wrap-item d-flex justify-content-between align-items-center mb-3">
                                <div class="score-wrap-item-title w-75">
                                    <h5 class="mb-1">{{ item.name }}</h5>
                                </div>
                                <div class="score-wrap-item-score w-25 d-flex justify-content-end">
                                    <div class="score-wrap-item-score-box text-center font-weight-bold"
                                        :style="scoreStyles[index]">
                                        <countTo :startVal="0" :endVal="item.score" :duration="1000" :decimals="1">
                                        </countTo>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="$auth.isAuthenticated"
                            class="account-wrap mt-3 animate__animated animate__fadeIn animate__duration-0.3s">
                            <div class="account-btn-wrap">
                                <b-button block pill variant="primary" @click="handleModalShow('account')"><i
                                        class="bi bi-person-circle mr-2"></i>My Account</b-button>
                                <img class="account-star" src="@/assets/imgs/account-star.png" alt="">
                            </div>
                            <!-- <p v-if="memberType === 'pro'" class="mt-2 text-secondary text-center h7">Pro Member</p>
                            <p v-else-if="memberType === 'free'" class="mt-2 text-secondary text-center h7">As a free member
                                you can submit your essay
                                <b class="text-primary">2</b> times
                            </p> -->
                        </div>
                        <div class="writing-type-wrap w-100 p-4">
                            <b-dropdown id="dropdown-dropup" dropup text="TOEFL Writing" variant="outline-gray"
                                class="col-12 mt-3 p-0">
                                <b-dropdown-item href="#" class="w-100">TOEFL Writing</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" class="h-100">
                    <div class="main-col writing-wrap d-flex flex-column h-100">
                        <div class="writing-wrap-title">
                            <b-form-textarea v-show="enableEdit"
                                class="writing-wrap-title-textarea border-0 my-3 font-weight-bolder text-dark animate__animated animate__fadeIn animate__duration-0.3s"
                                v-model="essayTitle" no-resize @focus="essayTitleChanged = false"
                                @change="essayTitleChanged = true" @blur="handleEssayTitleBlur"
                                placeholder='Add your topic here. For example, Do you agree or disagree with the following statement: “It is more important for students to study ...”'></b-form-textarea>
                            <div v-show="!enableEdit" class="writing-wrap-title-textarea my-3 font-weight-bolder text-dark">
                                {{ essayTitle }}</div>
                        </div>
                        <div class="writing-wrap-content flex-1">
                            <b-form-textarea v-show="enableEdit"
                                class="writing-wrap-content-textarea border-0 h-100 text-dark animate__animated animate__fadeIn animate__duration-0.3s"
                                v-model="essayBody" no-resize @focus="essayBodyChanged = false"
                                @change="essayBodyChanged = true" @blur="handleEssayBodyBlur"
                                placeholder="Add your essay response here."></b-form-textarea>
                            <div v-show="!enableEdit" class="writing-wrap-content-textarea h-100 text-dark">
                                <template v-for="(item, index) in generateEssayBody">
                                    <template v-if="item.feedback">
                                        <span
                                            class="text-danger text-pointer text-hover-underline animate__animated animate__fadeIn animate__duration-0.3s"
                                            v-html="item.words" @click="handleWordsClick(item.index)"></span>
                                    </template>
                                    <span v-else v-html="item.words"></span>
                                </template>
                            </div>
                        </div>
                        <div class="writing-wrap-options d-flex justify-content-between align-items-center p-4">
                            <div class="d-flex align-items-center text-secondary">
                                <small>Characters: {{ essayBody.length }}</small>
                                <span class="mx-2">|</span>
                                <small>Words: {{ wordsNum }}</small>
                            </div>
                            <div v-if="!$auth.loading" class="animate__animated animate__fadeIn animate__duration-0.3s">
                                <template v-if="!$auth.isAuthenticated">
                                    <b-button pill variant="primary" :disabled="!enableSubmit || loading.submit"
                                        @click="handleLogin"><b-spinner :hidden="!loading.submit"
                                            small></b-spinner>Submit</b-button>
                                </template>
                                <template v-else>
                                    <b-button v-if="generate" pill variant="outline-primary"
                                        @click="handleReset">Reset</b-button>
                                    <b-button v-else pill variant="primary" :disabled="!enableSubmit || loading.submit"
                                        @click="handleSubmit"><b-spinner :hidden="!loading.submit" class="mr-1"
                                            small></b-spinner>Submit</b-button>
                                    <Modal :show="show.count" noCloseOnBackdrop noCloseOnEsc noCloseButton
                                        title="Generating Essay Feedback" @onClose="handleModalClose('count')">
                                        <template v-slot:content>
                                            <img class="loading-img" src="@/assets/imgs/loading.gif" alt="">
                                            <p>{{ count }} seconds remain until your essay feedback is generated.
                                                Please don't close or refresh the window.</p>
                                        </template>
                                    </Modal>
                                </template>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="3" class="h-100">
                    <div class="main-col border-left d-flex flex-column p-4">
                        <b-tabs content-class="mt-3" v-model="activeTabIndex">
                            <b-tab title="Sentence/word feedback">
                                <div class="feedback-wrap">
                                    <div v-for="(item, index) in sentencFeedbackTemp" class="mb-3">
                                        <Collapse :key="item.feedbackIndex"
                                            :title="`Sentence/word feedback ${item.feedbackIndex + 1}`" :show="generate"
                                            :error="index === feedbackIndex">
                                            <template v-slot:content>
                                                <div
                                                    class="border-top mt-2 animate__animated animate__fadeIn animate__duration-0.3s">
                                                    <b-badge pill variant="info"
                                                        class="py-3 px-4 my-3 feedback-badge">Suggested
                                                        replacement</b-badge>
                                                    <div class="">{{ item.target }}</div>
                                                    <b-badge pill variant="info"
                                                        class="py-3 px-4 my-3 feedback-badge">Feedback</b-badge>
                                                    <div class="">{{ item.feedback }}</div>
                                                </div>
                                            </template>
                                        </Collapse>
                                    </div>
                                    <div v-if="!sentencFeedbackTemp.length"
                                        class="suggestions-content-wrap-empty d-flex flex-column justify-content-center align-items-center p-4 animate__animated animate__fadeIn animate__duration-0.3s">
                                        <img class="suggestions-content-wrap-empty-img"
                                            src="@/assets/imgs/empty/suggestions-empty.png" alt="">
                                        <div class="text-dark font-weight-bolder h5">It’s all empty here</div>
                                        <div class="text-dark text-center h6">Start writing for Proofy to give writing
                                            <br />style
                                            suggestions
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Essay feedback">
                                <div class="feedback-wrap">
                                    <div v-for="(item, index) in scoreResults" class="mb-3">
                                        <Collapse :key="index" v-if="item.hasDetail" :title="item.name"
                                            :content="item.detail" :show="generate">
                                        </Collapse>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-col>
            </b-row>
        </div>
        <Account v-if="$auth.isAuthenticated" :show="show.account" @onClose="handleModalClose('account')"
            @onCancelMembership="handleCancelMembership">
        </Account>
    </b-container>
</template>
  
<script>
import { objDeepCopy } from '@/utils'
import { isEmpty, isObject } from '@/utils/types'
import { essaySubmit1API, essaySubmit2API } from '@/api/writing'
import { checkUserPayStatusAPI } from '@/api/user'

import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import Modal from '@/components/modal/Modal'
import Account from '@/components/account'
import Collapse from '@/components/collapse'
import * as amplitude from '@amplitude/analytics-browser'
import countTo from 'vue-count-to'

export default {
    name: 'Writing',
    components: {
        Modal,
        Account,
        Collapse,
        countTo,
    },
    data() {
        return {
            scoreStyles: [
                { background: '#F1E2FF', color: '#864FB9', },
                { background: '#FFDDE2', color: '#C52C2C', },
                { background: '#E1E7FF', color: '#322F81', },
                { background: '#DDFDF5', color: '#339070', },
                { background: '#FFE6CA', color: '#7E2E13', },
            ],
            scoreResults: [
                { type: 'topic', name: 'Quality of Ideas', hasDetail: true, score: 0 },
                { type: 'grammar', name: 'Grammar', hasDetail: true, score: 0 },
                { type: 'organization', name: 'Organization', hasDetail: true, score: 0 },
                { type: 'structure', name: 'Writing Style', hasDetail: true, score: 0 },
                { type: 'overall_score', name: 'Summary', score: 0 },
            ],
            totalScore: 0, // 总分：overall_score 乘以 6 取整数部分
            essayTitle: '',
            essayTitleChanged: false,
            essayBody: '',
            essayBodyChanged: false,
            generateEssayBody: [],
            enableEdit: true, // 可编辑
            generate: false, // 已提交生成分数
            modalType: 'info',
            modalTitle: '',
            modalContent: '',
            loading: {
                submit: false
            },
            show: { // modal显示控制参数集合
                works: false,
                msg: false,
                account: false,
                count: false,
            },
            memberType: '',
            dismissSecs: 5,
            dismissCountDown: 0,
            showDismissibleAlert: false,
            submitSuccessNum: 0,
            essayFeedback: {},
            sentencFeedback: [],
            sentencFeedbackTemp: [],
            activeTabIndex: 0,
            feedbackIndex: null,
            count: 180,
        }
    },
    computed: {
        enableSubmit() {
            return !isEmpty(this.essayTitle.trim()) && !isEmpty(this.essayBody.trim())
        },
        wordsNum() {
            let trimBody = this.essayBody.replace(/\n|\r|^\s+|\s+$/gi, "").replace(/\s+/gi, " ")
            return isEmpty(trimBody) ? 0 : trimBody.split(' ').length
        },
        userId() {
            return this.$auth.user.sub && this.$auth.user.sub.replace('auth0|', 'auth0_') || ''
        }
    },
    watch: {
        '$auth.user.sub': {
            handler(newVal, oldVal) {
                if (!isEmpty(newVal)) {
                    this.checkUserPayStatus()

                    // 绑定埋点用户
                    amplitude.setUserId(this.userId);
                }
            },
            immediate: true
        },
        '$auth.loading': {
            handler(newVal, oldVal) {
                if (!newVal) {
                    NProgress.done()
                }
            },
            immediate: true
        },
    },
    created() {
        // 初始化埋点
        amplitude.init('56d0c019f1e937e61440d6ba33f42d57')
        // 埋点
        amplitude.track('User enter')

        NProgress.start()
    },
    mounted() { },
    methods: {
        // 检查用户付费状态
        checkUserPayStatus() {
            let params = {
                userId: this.userId,
            }

            checkUserPayStatusAPI(params).then(data => {
                this.memberType = data.is_paid ? 'pro' : 'free'
                this.$auth.user.isPro = data.is_paid

                NProgress.done()
            }).catch(error => {
                this.$error(error.response.data.error)

                NProgress.done()
            })

            // 埋点
            amplitude.track('Check user pay status')
        },
        // 登录
        handleLogin() {
            this.$auth.loginWithPopup();

            // 埋点
            amplitude.track('User login')
        },
        handleModalShow(name) {
            this.show[name] = true
        },
        handleModalClose(name) {
            this.show[name] = false
        },
        handleEssayTitleBlur() {
            if (!isEmpty(this.essayTitle) && this.essayTitleChanged) {
                // 埋点
                amplitude.track('User input topic')
            }
        },
        handleEssayBodyBlur() {
            if (!isEmpty(this.essayBody) && this.essayBodyChanged) {
                // 埋点
                amplitude.track('User input essay')
            }
        },
        // 提交
        handleSubmit() {
            this.loading.submit = true
            this.enableEdit = false
            this.submitSuccessNum = 0

            this.generateEssayBody = this.handleGenerateBody([], this.essayBody)

            let params = {
                title: this.essayTitle,
                body: this.essayBody,
                userId: this.userId,
            }

            // 倒计时
            this.show.count = true
            this.count = 180
            let that = this, timer = setInterval(() => {
                --that.count
                if (that.count <= 0) {
                    clearInterval(timer)
                }
            }, 1000)

            // 同时提交
            this.handleSubmit1(params, timer)
            this.handleSubmit2(params, timer)

            // 埋点
            amplitude.track('User submit')
        },
        handleSubmit1(params, timer) {
            // demo data
            // this.essayFeedback = { "overall_score": 4.5, "score_breakdown": [{ "type": "topic", "score": 5, "feedback": "The essay adequately addresses the prompt and fulfills the requirements of the essay task." }, { "type": "organization", "score": 4.5, "feedback": "The essay has a clear structure and logical progression of ideas. The introduction, body paragraphs, and conclusion are well-organized." }, { "type": "structure", "score": 4.5, "feedback": "The essay demonstrates the ability to develop ideas and provide appropriate support for arguments. The depth and clarity of thoughts are good, and the examples, details, and evidence used to support points are appropriate." }, { "type": "grammar", "score": 4.5, "feedback": "The essay demonstrates a good command of English language skills, including grammar, vocabulary, and sentence structure. The language use is accurate and appropriate, and the vocabulary choices are varied and sophisticated." }] }

            essaySubmit1API(params).then(data => {
                if (!isObject(data)) {
                    this.$modal({
                        type: 'error',
                        title: 'Failed',
                        content: 'Please try again. Do you submit a valid essay topic and answer?',
                    })

                    this.enableEdit = true
                } else {
                    this.essayFeedback = data

                    if (this.submitSuccessNum > 0) {
                        this.handleSubmitSuccess(timer)
                    } else {
                        ++this.submitSuccessNum
                    }
                }

                if (this.submitSuccessNum >= 2) {
                    this.loading.submit = false
                }
            }).catch(error => {
                this.loading.submit = false
                this.enableEdit = true
                this.show.count = false
                clearInterval(timer)

                let content = error.response ? error.response.data.error : error.message || 'Please try again. Do you submit a valid essay topic and answer?'
                this.$modal({
                    type: 'error',
                    title: 'Failed',
                    content
                })
            })
        },
        handleSubmit2(params, timer) {
            // demo data
            // let data = { "detailed_feedback": [{ "source": "I partially disagree with the statement that we can learn more from people whose views we share then from people whose views contradict our own.", "context": "", "target": "I partially disagree with the statement that we can learn more from people whose views we share than from people whose views contradict our own.", "feedback": "The word 'then' should be replaced with 'than' for better clarity and coherence." }, { "source": "In many cases a familiarity with a diversity of opinions is good to have when trying to find the most valid line of thought.", "context": "", "target": "In many cases, a familiarity with a diversity of opinions is beneficial when trying to find the most valid line of thought.", "feedback": "The phrase 'good to have' can be replaced with 'beneficial' for better clarity and conciseness." }, { "source": "However there are some times when it can be disadvantageous.", "context": "", "target": "However, there are times when it can be disadvantageous.", "feedback": "The phrase 'some times' should be replaced with 'times' for better clarity and coherence." }, { "source": "When approaching a topic it is important to not see only one point of view but to see it from as many points of view as possible.", "context": "", "target": "When approaching a topic, it is important to not only see one point of view but to see it from as many perspectives as possible.", "feedback": "The phrase 'points of view' should be replaced with 'perspectives' for better clarity and conciseness." }, { "source": "Even if only one is the correct understanding the arguments against that view give a deeper understanding of why it is correct.", "context": "", "target": "Even if only one is the correct understanding, the arguments against that view give a deeper understanding of why it is correct.", "feedback": "The phrase 'the arguments against that view' should be preceded by a comma for better clarity and coherence." }, { "source": "If one dismisses other views out of hand and looks no deeper into them it is easy to ignore routes that seem at a first glance to be invalid.", "context": "", "target": "If one dismisses other views out of hand and does not look deeper into them, it is easy to ignore routes that seem invalid at first glance.", "feedback": "The phrase 'at a first glance' should be replaced with 'at first glance' for better clarity and conciseness." }, { "source": "In addition, it can result in having not counter to that view should it need to be corrected and so can delegitimize the correct view and lead others to believe that they are being unfairly dismissed.", "context": "", "target": "In addition, it can result in not having a counter to that view should it need to be corrected, and so can delegitimize the correct view and lead others to believe that they are being unfairly dismissed.", "feedback": "The phrase 'having not counter' should be replaced with 'not having a counter' for better clarity and coherence." }] }
            // this.sentencFeedback = data.detailed_feedback

            essaySubmit2API(params).then(data => {
                if (!isObject(data)) {
                    this.$modal({
                        type: 'error',
                        title: 'Failed',
                        content: 'Please try again. Do you submit a valid essay topic and answer?',
                    })

                    this.enableEdit = true
                } else {
                    this.sentencFeedback = data.detailed_feedback

                    if (this.submitSuccessNum > 0) {
                        this.handleSubmitSuccess(timer)
                    } else {
                        ++this.submitSuccessNum
                    }
                }
                if (this.submitSuccessNum >= 2) {
                    this.loading.submit = false
                }
            }).catch(error => {
                this.loading.submit = false
                this.enableEdit = true
                this.show.count = false
                clearInterval(timer)

                let content = error.response ? error.response.data.error : error.message || 'Please try again. Do you submit a valid essay topic and answer?'
                this.$modal({
                    type: 'error',
                    title: 'Failed',
                    content
                })
            })
        },
        // 提交成功
        handleSubmitSuccess(timer) {
            this.loading.submit = false
            this.show.count = false
            clearInterval(timer)

            this.handleEssayFeedback(this.essayFeedback)
            this.handleSentencFeedback(this.sentencFeedback)

            this.generate = true
        },
        handleEssayFeedback(data) {
            let obj = {
                overall_score: {
                    score: data.overall_score
                }
            }
            data.score_breakdown.forEach(item => {
                obj[item.type] = {
                    score: item.score,
                    detail: item.feedback
                }
            })

            this.scoreResults.forEach(item => {
                item.hasDetail && (item.detail = obj[item.type].detail)
                item.score = obj[item.type].score
            })

            this.totalScore = parseInt(data.overall_score * 6)
        },
        handleSentencFeedback(data) {
            if (isEmpty(data)) {
                this.sentencFeedback = []
                this.sentencFeedbackTemp = []
                return
            }

            const tempData = [], tempData1 = []

            data.forEach(item => {
                if (!isEmpty(item.source) && !isEmpty(item.feedback) && this.essayBody.indexOf(item.source) > -1) {
                    tempData.push(objDeepCopy(item))
                }
            })
            this.sentencFeedback = tempData

            tempData.forEach((item, index) => {
                item.feedbackIndex = index
                tempData1.push(objDeepCopy(item))
            })
            this.sentencFeedbackTemp = tempData1

            this.generateEssayBody = this.handleGenerateBody(tempData, this.essayBody)
        },
        handleGenerateBody(feedback, body) {
            body = body.replace(/\n|\r/gi, "<br/>")

            if (isEmpty(feedback)) {
                return [{
                    words: body,
                }]
            }

            let result = []

            feedback.forEach((item, index) => {
                let source = item.source.replace(item.source, `-|s|-${item.source}-|f|-${index}-|s|-`),
                    reg = new RegExp(`(?<![a-zA-Z])${item.source}(?![a-zA-Z])`)

                body = body.replace(reg, source)
            })
            
            body.split('-|s|-').forEach(item => {
                let wordList = item.split('-|f|-')

                result.push({
                    words: wordList[0],
                    index: wordList[1],
                    feedback: !isEmpty(wordList[1]),
                })
            })

            return result
        },
        // 重置
        handleReset() {
            this.scoreResults = [
                { type: 'topic', name: 'Quality of Ideas', hasDetail: true, score: 0 },
                { type: 'grammar', name: 'Grammar', hasDetail: true, score: 0 },
                { type: 'organization', name: 'Organization', hasDetail: true, score: 0 },
                { type: 'structure', name: 'Writing Style', hasDetail: true, score: 0 },
                { type: 'overall_score', name: 'Summary', score: 0 },
            ]
            this.totalScore = 0
            this.essayTitle = ''
            this.essayBody = ''
            this.generateEssayBody = []
            this.enableEdit = true
            this.generate = false
            this.submitSuccessNum = 0
            this.essayFeedback = {}
            this.sentencFeedback = []
            this.sentencFeedbackTemp = []
            this.activeTabIndex = 0
            this.feedbackIndex = null
        },
        handleCancelMembership() {
            this.$alert('Your subscription is cancelled.')
        },
        handleWordsClick(feedbackIndex) {
            this.activeTabIndex = 0
            this.feedbackIndex = 0

            let targetIndex = 0

            this.sentencFeedbackTemp.forEach((item, index) => {
                if (feedbackIndex == item.feedbackIndex) {
                    targetIndex = index
                }
            })

            this.sentencFeedbackTemp.unshift(...this.sentencFeedbackTemp.splice(targetIndex, 1))
        }
    }
}
</script>
  
<style scoped lang="scss">
/deep/ ul.nav>li.nav-item {
    width: 50%;
}

/deep/ ul.nav>li.nav-item>a.nav-link {
    border: none;
    border-bottom: 2px solid #d6e9f0;
    color: $dark;
    font-weight: bold;
    padding: 0.5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/deep/ ul.nav>li.nav-item>a.nav-link.active {
    border: none;
    border-bottom: 2px solid $primary;
    color: $primary;
}

.sentence-error {
    color: $blue;
}

.main {
    height: 100vh;

    .main-col {
        position: relative;
        height: 100%;
        overflow: auto;
    }

    .logo-wrap {
        &-img {
            width: 5rem;
            max-width: 50%;
        }
    }

    .predicted-score-wrap {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.05);

        &-text {
            width: 5rem;
            height: 5rem;
            line-height: 5rem;
            background: #D2F3FF;
        }

        &-title {
            max-width: calc(100% - 6rem);
        }
    }

    .score-wrap {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.05);

        &-item {
            &-score {
                &-box {
                    width: 4rem;
                    height: 2.6rem;
                    line-height: 2.6rem;
                    border-radius: 1.3rem;
                }
            }
        }
    }

    .account-wrap {
        .account-btn-wrap {
            position: relative;
        }

        .account-star {
            position: absolute;
            top: -0.3rem;
            right: -0.3rem;
            width: 1.6rem;
        }
    }

    .writing-type-wrap {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .writing-wrap {

        &-title {
            &-textarea {
                font-size: 1.25rem;
                height: 7rem;
                padding: 0.4rem 1.5rem;
            }
        }

        &-content {
            overflow: auto;

            &-textarea {
                line-height: 1.8rem;
                padding: 0.4rem 1.5rem;
            }
        }
    }

    .feedback-wrap {
        overflow: auto;

        .feedback-badge {
            color: #339070;
            background-color: #DDFDF5;
        }
    }

    .suggestions-title-wrap {
        &-count {
            width: 2.2rem;
            height: 2rem;
            line-height: 2rem;
            border-radius: 1rem;
            background: #DDFDF5;
            color: #339070;
        }
    }

    .suggestions-content-wrap {
        &-empty {
            margin-top: 60%;

            &-img {
                width: 20rem;
                max-width: 80%;
                margin-top: -7rem;
            }
        }
    }
}

.form-control:focus {
    border-color: inherit;
    box-shadow: none;
}

.btn {
    padding: 0.8rem 2.3rem;
    font-weight: 500;
}

.feedback-popover {
    &-badge {
        color: #C52C2C;
        background-color: #FFD2D8;
    }
}

.loading-img {
    display: block;
    width: 100px;
    margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Writing/index.vue